import {useEffect, useMemo} from "react";
import {useFranchiseSerials} from "../../hooks/UseFranchiseSerials";
import {useSerials} from "../../hooks/UseSerials";
import {SerialSearchSelect} from "./SerialSearchSelect";
import Poster from "../../display/serials/Poster";
import {Link} from "react-router-dom";

export function EditFranchiseSerials({user, franchiseId}) {
    const fsHook = useFranchiseSerials();
    const sHook = useSerials();

    useEffect(() => {
        if (user?.token && franchiseId) {
            fsHook.loadSerials(user.token, franchiseId);
        }
    }, [user, franchiseId, user?.token]);

    const onAddClicked = async (serial) => {
        if (fsHook.franchiseSerials?.some(s => s.serialId === serial.id)) {
            alert("Цей серіал вже є у франшизі");
            return;
        }

        const nextOrder = (fsHook.franchiseSerials?.length || 0);

        await fsHook.createFranchiseSerial(user.token, franchiseId, serial.id, nextOrder);
        fsHook.loadSerials(user.token, franchiseId);
    };

    const onDeleteClicked = async (serialId) => {
        if (window.confirm("Вилучити цей серіал з франшизи?")) {
            await fsHook.deleteFranchiseSerial(user.token, franchiseId, serialId);
            fsHook.loadSerials(user.token, franchiseId);
        }
    };

    const existingIds = useMemo(() =>
            (fsHook.franchiseSerials || []).map(fs => fs.serialId),
        [fsHook.franchiseSerials]
    );

    // ORDER CHANGE
    const moveItem = async (index, direction) => {
        const items = [...fsHook.franchiseSerials].sort((a, b) => a.orderIndex - b.orderIndex);
        const targetIndex = index + direction;

        if (targetIndex < 0 || targetIndex >= items.length) return;

        const currentItem = items[index];
        const targetItem = items[targetIndex];

        // swap indexes
        const originalOrder = currentItem.orderIndex;
        currentItem.orderIndex = targetItem.orderIndex;
        targetItem.orderIndex = originalOrder;

        // sending update for both elements
        await fsHook.updateFranchiseSerial(user.token, franchiseId, currentItem.serialId, currentItem.orderIndex);
        await fsHook.updateFranchiseSerial(user.token, franchiseId, targetItem.serialId, targetItem.orderIndex);

        // reload list
        fsHook.loadSerials(user.token, franchiseId);
    };

    const currentSerials = [...(fsHook.franchiseSerials || [])].sort((a, b) => a.orderIndex - b.orderIndex);

    return (
        <div style={{
            marginTop: '30px',
            padding: '20px',
            backgroundColor: '#fff',
            borderRadius: '12px',
            border: '1px solid #e5e7eb'
        }}>
            <h3 style={{
                margin: '0 0 15px 0',
                fontSize: '16px',
                color: '#111827',
                display: 'flex',
                alignItems: 'center',
                gap: '8px'
            }}>
                📂 Склад франшизи
            </h3>

            <div style={{marginBottom: '20px'}}>
                <SerialSearchSelect
                    token={user?.token}
                    loadAll={sHook.loadAll}
                    placeholder="Додати аніме до франшизи..."
                    onSelect={onAddClicked}
                    excludeIds={existingIds}
                />
            </div>

            <div style={{display: 'flex', flexDirection: 'column', gap: '10px'}}>
                {currentSerials.length > 0 ? (
                    currentSerials.map((fs, index) => (
                        <div key={fs.serialId} style={{
                            display: 'flex', alignItems: 'center', gap: '12px', padding: '10px',
                            border: '1px solid #f3f4f6', borderRadius: '10px', backgroundColor: '#f9fafb',
                            transition: 'transform 0.2s'
                        }}>
                            {/* sorting buttons */}
                            <div style={{display: 'flex', flexDirection: 'column', gap: '2px'}}>
                                <button
                                    type="button"
                                    disabled={index === 0}
                                    onClick={() => moveItem(index, -1)}
                                    style={{
                                        cursor: index === 0 ? 'default' : 'pointer',
                                        border: 'none',
                                        background: index === 0 ? 'transparent' : '#eee',
                                        borderRadius: '4px',
                                        padding: '2px 6px',
                                        fontSize: '10px',
                                        color: index === 0 ? '#ccc' : '#444'
                                    }}
                                >▲
                                </button>
                                <button
                                    type="button"
                                    disabled={index === currentSerials.length - 1}
                                    onClick={() => moveItem(index, 1)}
                                    style={{
                                        cursor: index === currentSerials.length - 1 ? 'default' : 'pointer',
                                        border: 'none',
                                        background: index === currentSerials.length - 1 ? 'transparent' : '#eee',
                                        borderRadius: '4px',
                                        padding: '2px 6px',
                                        fontSize: '10px',
                                        color: index === currentSerials.length - 1 ? '#ccc' : '#444'
                                    }}
                                >▼
                                </button>
                            </div>

                            <div style={{
                                width: '40px',
                                height: '55px',
                                flexShrink: 0,
                                borderRadius: '4px',
                                overflow: 'hidden'
                            }}>
                                <Poster link={fs.serial?.posterUrl}/>
                            </div>

                            <div style={{flexGrow: 1}}>
                                <div style={{
                                    fontSize: '14px',
                                    fontWeight: '600',
                                    color: '#1f2937',
                                    display: 'flex',
                                    flexWrap: 'wrap',
                                    alignItems: 'center',
                                    gap: '6px'
                                }}>
                                    <Link
                                        to={`/serials/edit?id=${fs.serialId}`}
                                        style={{
                                            color: '#4F46E5FF',
                                            textDecoration: 'none',
                                            transition: 'color 0.2s'
                                        }}
                                        onMouseOver={(e) => e.target.style.color = '#3730a3'}
                                        onMouseOut={(e) => e.target.style.color = '#4F46E5FF'}
                                    >
                                        {fs.serial?.name || "Без назви"}
                                    </Link>

                                    <div style={{display: 'flex', gap: '4px', alignItems: 'center'}}>
                                        {fs.serial?.year && (
                                            <span style={{fontWeight: '400', color: '#9ca3af', fontSize: '12px'}}>({fs.serial.year})</span>
                                        )}

                                        {fs.serial?.season && (
                                            <span style={{
                                                backgroundColor: '#eef2ff',
                                                color: '#6366f1',
                                                padding: '1px 6px',
                                                borderRadius: '4px',
                                                fontSize: '11px',
                                                fontWeight: '700',
                                                border: '1px solid #e0e7ff'
                                            }}>{fs.serial.season}</span>
                                        )}
                                    </div>
                                </div>
                                <div style={{fontSize: '11px', color: '#6b7280'}}>Порядок: {fs.orderIndex + 1}</div>
                            </div>

                            <button
                                type="button"
                                onClick={() => onDeleteClicked(fs.serialId)}
                                style={{
                                    color: '#fca5a5',
                                    border: 'none',
                                    background: 'none',
                                    cursor: 'pointer',
                                    padding: '5px',
                                    fontSize: '18px'
                                }}
                                onMouseEnter={(e) => e.target.style.color = '#ef4444'}
                                onMouseLeave={(e) => e.target.style.color = '#fca5a5'}
                            >🗑️
                            </button>
                        </div>
                    ))
                ) : (
                    <div style={{
                        textAlign: 'center',
                        padding: '20px',
                        color: '#9ca3af',
                        fontSize: '13px',
                        border: '2px dashed #f3f4f6',
                        borderRadius: '10px'
                    }}>
                        Франшиза порожня. Використайте пошук вище.
                    </div>
                )}
            </div>
        </div>
    );
}